/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioCmp2 } from './pages'

type TIdToPageMapStylioCmp2 = Record<PageIdStylioCmp2, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_CMP2: TIdToPageMapStylioCmp2 = {
  [PageIdStylioCmp2.AGE_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/AgeQuestion'),
  },
  [PageIdStylioCmp2.CURRENT_WARDROBE_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/CurrentWardrobeQuestion'
      ).then((m) => ({
        default: m.CurrentWardrobeQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/CurrentWardrobeQuestion'
      ),
  },
  [PageIdStylioCmp2.URGE_1_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_cmp2/pages/urge/UrgePage'),
  },
  [PageIdStylioCmp2.WARDROBE_GOAL_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/WardrobeGoalQuestion'
      ).then((m) => ({
        default: m.WardrobeGoalQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/WardrobeGoalQuestion'),
  },
  [PageIdStylioCmp2.HAIR_COLOR_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioCmp2.EYES_COLOR_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioCmp2.SKIN_COLOR_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/SkinColorQuestion'
      ).then((m) => ({
        default: m.SkinColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/SkinColorQuestion'),
  },
  [PageIdStylioCmp2.JEWELRY_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/JewelryQuestion').then(
        (m) => ({
          default: m.JewelryQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioCmp2.COLOR_PALETTE_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/ColorPaletteQuestion'
      ).then((m) => ({
        default: m.ColorPaletteQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/ColorPaletteQuestion'),
  },
  [PageIdStylioCmp2.COLOR_HARMONY_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/ColorHarmonyQuestion'
      ).then((m) => ({
        default: m.ColorHarmonyQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/ColorHarmonyQuestion'),
  },
  [PageIdStylioCmp2.URGE_6_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgeAiColorPage').then(
        (m) => ({
          default: m.UrgeAiColorPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgeAiColorPage'),
  },
  [PageIdStylioCmp2.BODY_SHAPE_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioCmp2.TALL_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/TallQuestion'),
  },
  [PageIdStylioCmp2.WEIGHT_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/WeightQuestion').then(
        (m) => ({
          default: m.WeightQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/WeightQuestion'),
  },
  [PageIdStylioCmp2.URGE_5_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioCmp2.FEEL_ABOUT_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/FeelAboutQuestion'
      ).then((m) => ({
        default: m.FeelAboutQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/FeelAboutQuestion'),
  },
  [PageIdStylioCmp2.URGE_2_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/urge/UrgeCapsuleTailoredPage'
      ).then((m) => ({
        default: m.UrgeCapsuleTailoredPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgeCapsuleTailoredPage'),
  },
  [PageIdStylioCmp2.STYLE_COMPLIMENTS_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/StyleComplimentsQuestion'
      ).then((m) => ({
        default: m.StyleComplimentsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/StyleComplimentsQuestion'
      ),
  },
  [PageIdStylioCmp2.PERCENTAGE_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/PercentageQuestion'
      ).then((m) => ({
        default: m.PercentageQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/PercentageQuestion'),
  },
  [PageIdStylioCmp2.SHOPPING_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/ShoppingQuestion').then(
        (m) => ({
          default: m.ShoppingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioCmp2.STYLE_MOST_MATTERS_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislike'
      ).then((m) => ({
        default: m.LikeOrDislikeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislike'),
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_11_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant11'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant11Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant11'
      ),
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_12_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant12'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant12Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant12'
      ),
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_13_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant13'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant13Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant13'
      ),
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_14_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant14'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant14Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant14'
      ),
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_15_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant15'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant15Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant15'
      ),
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_16_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant16'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant16Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant16'
      ),
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_17_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant17'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant17Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant17'
      ),
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_18_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant18'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant18Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant18'
      ),
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_19_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant19'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant19Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/likeOrDislike/LikeOrDislikeVariant19'
      ),
  },
  [PageIdStylioCmp2.STYLES_FEEL_LIKE_YOU_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/StylesFeelLikeYouQuestion'
      ).then((m) => ({
        default: m.StylesFeelLikeYouQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/StylesFeelLikeYouQuestion'
      ),
  },
  [PageIdStylioCmp2.URGE_3_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioCmp2.URGE_4_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgeBodyShapePage').then(
        (m) => ({
          default: m.UrgeBodyShapePage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgeBodyShapePage'),
  },
  [PageIdStylioCmp2.BODY_SHAPE_CONFIDENCE_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/BodyShapeConfidenceQuestion'
      ).then((m) => ({
        default: m.BodyShapeConfidenceQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/BodyShapeConfidenceQuestion'
      ),
  },
  [PageIdStylioCmp2.OUTFIT_ON_OTHERS_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/OutfitOnOthersQuestion'
      ).then((m) => ({
        default: m.OutfitOnOthersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/OutfitOnOthersQuestion'
      ),
  },
  [PageIdStylioCmp2.DRAW_LESS_ATTENTION_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/DrawLessAttentionQuestion'
      ).then((m) => ({
        default: m.DrawLessAttentionQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/DrawLessAttentionQuestion'
      ),
  },
  [PageIdStylioCmp2.BRAND_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/BrandQuestion').then(
        (m) => ({
          default: m.BrandQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/BrandQuestion'),
  },
  [PageIdStylioCmp2.AVOID_COLORS_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/AvoidColorsQuestion'
      ).then((m) => ({
        default: m.AvoidColorsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/AvoidColorsQuestion'),
  },
  [PageIdStylioCmp2.AVOIDED_COLORS_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/AvoidedColorsQuestion'
      ).then((m) => ({
        default: m.AvoidedColorsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/AvoidedColorsQuestion'),
  },
  [PageIdStylioCmp2.URGE_7_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgeWellDonePage').then(
        (m) => ({
          default: m.UrgeWellDonePage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgeWellDonePage'),
  },
  [PageIdStylioCmp2.FIND_NEW_CLOTHES_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioCmp2.JACKET_COAT_BUDGET_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/BudgetQuestion').then(
        (m) => ({
          default: m.JacketCoatBudgetQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/BudgetQuestion'),
  },
  [PageIdStylioCmp2.TOP_BUDGET_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/BudgetQuestion').then(
        (m) => ({
          default: m.TopBudgetQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/BudgetQuestion'),
  },
  [PageIdStylioCmp2.BOTTOM_BUDGET_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/BudgetQuestion').then(
        (m) => ({
          default: m.BottomBudgetQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/BudgetQuestion'),
  },
  [PageIdStylioCmp2.SHOES_BUDGET_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/BudgetQuestion').then(
        (m) => ({
          default: m.ShoesBudgetQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/BudgetQuestion'),
  },
  [PageIdStylioCmp2.EXCITED_CAPSULE_PLAN_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/ExcitedCapsulePlanQuestion'
      ).then((m) => ({
        default: m.ExcitedCapsulePlanQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/ExcitedCapsulePlanQuestion'
      ),
  },
  [PageIdStylioCmp2.URGE_8_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioCmp2.YOUR_LOCATION_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/YourLocationQuestion'
      ).then((m) => ({
        default: m.YourLocationQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/questions/YourLocationQuestion'),
  },
  [PageIdStylioCmp2.WARDROBE_REFRESH_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/WardrobeRefreshQuestion'
      ).then((m) => ({
        default: m.WardrobeRefreshQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/WardrobeRefreshQuestion'
      ),
  },
  [PageIdStylioCmp2.SEASON_CHANGE_CHALLENGES_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/SeasonChangeChallengesQuestion'
      ).then((m) => ({
        default: m.SeasonChangeChallengesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/SeasonChangeChallengesQuestion'
      ),
  },
  [PageIdStylioCmp2.LIFESTYLE_MATCH_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/LifestyleMatchQuestion'
      ).then((m) => ({
        default: m.LifestyleMatchQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/LifestyleMatchQuestion'
      ),
  },
  [PageIdStylioCmp2.WEEKEND_ACTIVITIES_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/WeekendActivitiesQuestion'
      ).then((m) => ({
        default: m.WeekendActivitiesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/WeekendActivitiesQuestion'
      ),
  },
  [PageIdStylioCmp2.OUTFIT_OCCASIONS_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/OutfitOccasionsQuestion'
      ).then((m) => ({
        default: m.OutfitOccasionsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/questions/OutfitOccasionsQuestion'
      ),
  },
  [PageIdStylioCmp2.QUIZ_SUMMARY_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/QuizSummaryPage').then(
        (m) => ({
          default: m.QuizSummaryPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/urge/QuizSummaryPage'),
  },
  [PageIdStylioCmp2.PREPARE_FLOW_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioCmp2.EMAIL_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_cmp2/pages/email/Email'),
  },
  [PageIdStylioCmp2.EMAIL_CONSENT_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/stylio_cmp2/pages/email/EmailConsent'),
  },
  [PageIdStylioCmp2.SUBSCRIPTIONS_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/subscriptions/SubscriptionPage'
      ).then((m) => ({
        default: m.SubscriptionPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/subscriptions/SubscriptionPage'),
  },
  [PageIdStylioCmp2.CANCEL_OFFER_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/cancel-offer/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioCmp2.SUB_UPSELL_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCmp2.UPSELL_CMP2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp2/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_cmp2/pages/upsell/Upsell'),
  },
  [PageIdStylioCmp2.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioCmp2.DOWNLOAD_CMP2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp2/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp2/pages/download-app/DownloadDefault'),
  },
}
